module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reviews_count":"Review {count}"}}')
  delete Component.options._Ctor
}
